<div class="alert alert-warning m-0" role="alert" *ngIf="opened">
    <div class="alert-items">
        <div class="alert-item static">
            <div class="alert-icon-wrapper">
                <clr-icon class="alert-icon" shape="exclamation-triangle"></clr-icon>
            </div>
            <span class="alert-text">
                Acest site utilizează cookie pentru a vă asigura că beneficiați de cea mai bună experiență pe site-ul nostru.
                <a [routerLink]="['privacy-policy']">Aflați mai multe</a>
            </span>
            <div class="alert-actions">
                <div class="alert-action dropdown bottom-right open">
                    <button class="orange-button small" (click)="done()">Am înțeles</button>
                </div>
            </div>
        </div>
    </div>
</div>
